import {AbstractControl} from '@angular/forms';

export function validZipCode(c: AbstractControl): {[key: string]: any} | null {
    const test = c.value && /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(c.value);

    return test ? null : {invalidZipCode: c.value};
}
